<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sOGtUU/tc-custom/9781423641698.jpg?1709781776997" alt="This image is the cover for the book Gil Walsh Interiors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gil Walsh Interiors
      </h1>
      <p class="bookDescription body article font2">
        <b>The award-winning interior designer and owner of Gil Walsh Interiors shares her colorful approach to style in this beautifully illustrated volume.</b><br/>  <br/> Master colorist Gil Walsh has spent decades bringing her expertise to elegant homes from Pennsylvania to West Palm Beach, Martha’s Vineyard, and beyond. Now she brings readers into her creative process, showing how she helps clients express their personal lifestyles through inviting and gorgeously vibrant interiors.<br/>  <br/> With stunning photography, this volume demonstrates how color can be enjoyed with gusto, whether in pretty pastels or bold, bright hues. From beach houses in the Florida Keys to sky-scraping apartments in Palm Beach, historic landmark buildings such as Fallingwater and the Duquesne Club in Pennsylvania, and a cozy cottage on Martha’s Vineyard, Gil has applied her artistic eye and techniques to a wide variety of interiors and period styles.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gil Walsh, Margaret Reilly Muldoon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a24bbf0